import { InjectionToken } from "@angular/core";

export const BRAND_MAX_COUNT_TOKEN = new InjectionToken<number>(
  "BRAND_MAX_COUNT_TOKEN"
);

export const BRAND_BG_MAX_COUNT_TOKEN = new InjectionToken<number>(
  "BRAND_BG_MAX_COUNT_TOKEN"
);

export const BRAND_LOGO_MAX_COUNT_TOKEN = new InjectionToken<number>(
  "BRAND_LOGO_MAX_COUNT_TOKEN"
);

export const BRAND_OVERLAY_MAX_COUNT_TOKEN = new InjectionToken<number>(
  "BRAND_OVERLAY_MAX_COUNT_TOKEN"
);

export const BRAND_CAPTION_LOWER_THIRD_MAX_COUNT_TOKEN =
  new InjectionToken<number>("BRAND_CAPTION_LOWER_THIRD_MAX_COUNT_TOKEN");
